export default __webpack_public_path__ + "assets/ogg/7cc735e002979c1bb78f6daa3b299b90.ogg";